import React from 'react'
import { firestore, auth, signInWithGoogle } from '../../firebase/firebase-utils'
import { FormControl, InputGroup, Button, Image } from 'react-bootstrap'
import { DeleteComment } from './delete.post';

const AllComments = ({ docid, collection }) => {
    const [comments, setComments] = React.useState([]);
    const [User, setUser] = React.useState(null);
    const [reply, setReply] = React.useState('')

    auth.onAuthStateChanged(async user => {
        if (user) {
            await setUser(user)
        }
    })

    React.useEffect(() => {
        firestore.collection(collection).doc(docid).onSnapshot((feed) => {
            if (feed.exists) {
                var query = feed.data().comments;
                if (query) {
                    setComments(query)
                }
            }
        })
    }, [docid, collection, User])

    const PostComment = () => {
        if (reply !== '') {
            var allreplies = comments;
            allreplies.push({
                email: User.email,
                userImg: User.photoURL,
                username: User.displayName,
                query: Date.now(),
                descrip: reply
            })
            firestore.collection(collection).doc(docid).update({
                comments: allreplies
            })
            setReply('');
        } else { window.alert("please fill the field") }
    }

    return (
        <>
            {User
                ?
                <>
                    <br />
                    <InputGroup className="mb-3">
                        <FormControl
                            placeholder="Leave your comment ..."
                            as='textarea'
                            rows={1}
                            onChange={(e) => setReply(e.target.value)}
                            value={reply}
                        />
                        <InputGroup.Append>
                            <Button onClick={PostComment} variant="primary">Send</Button>
                        </InputGroup.Append>
                    </InputGroup>
                </>
                :
                <><p onClick={signInWithGoogle} style={{ fontFamily: 'Righteous', color: 'blue', cursor: 'pointer' }}>Sign In to comment</p><br /></>
            }
            <h4 style={{ fontFamily: 'Righteous', margin: '30px 0', color: '#0d3d63' }}>All Comments:{'  '}{comments.length}</h4>
            {
                comments.length !== 0 ?
                    comments.map(comment => (
                        <div key={comment.email} style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', lineHeight: '5px', margin: '10px 0'}}>
                                <Image style={{ height: '40px', borderRadius: '50%', marginRight: '10px', marginBottom: '8px', alignSelf: 'center' }} src={comment.userImg} fluid />
                                <div style={{ alignSelf: 'center' }}>
                                    <h5 style={{ fontSize: '16px', color: '#057BD0', fontFamily: 'Righteous' }}>{comment.username}</h5>
                                    <p style={{ fontSize: '12px' }}>{comment.email}</p>
                                </div>
                            </div>
                                <div style={{ background: '#e8effd', fontSize: '14px', borderRadius: '10px', padding: '10px', marginLeft: '20px', color: '#0d3d63',wordWrap:'break-word',maxWidth:'800px' }}>
                                    {comment.descrip}
                                    <span style={{float:'right',cursor:'pointer'}}><DeleteComment docid={docid} collection={collection} query={comment.query} /></span>
                                </div>
                            <span style={{ float: 'right', fontSize: '12px', color: 'orangered' }}>{new Date(comment.query).toISOString()}</span>
                        </div>
                    ))
                    :
                    <p>No comments</p>
            }
        </>
    )
}

export default AllComments
